    <span class="mat-label-small">Simply POS Frontend</span>